 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React, {useEffect, useRef} from 'react'
import {useFragment} from 'react-relay'

import {MenuPosition} from '~/hooks/useCoords'
import useMenu from '~/hooks/useMenu'
import lazyPreload from '~/utils/lazyPreload'
import useRouter from '../hooks/useRouter'
import TopBarIcon from './TopBarIcon'

const NotificationDropdown = lazyPreload(
  () =>
    import(
      /* webpackChunkName: 'NotificationDropdown' */
      './NotificationDropdown'
    )
)





const TopBarNotifications = ({queryRef}) => {
  const data = useFragment(
    graphql`
      fragment TopBarNotifications_query on Query {
        ...NotificationDropdown_query
        viewer {
          notifications(first: $first, after: $after)
            @connection(key: "NotificationDropdown_notifications") {
            edges {
              node {
                id
                status
              }
            }
          }
        }
      }
    `,
    queryRef
  )
  const {viewer} = data
  const notifications = _optionalChain([viewer, 'optionalAccess', _ => _.notifications]) || {edges: []}
  const {edges} = notifications
  const hasNotifications = edges.some(({node}) => node.status === 'UNREAD')
  const menuContentRef = useRef(null)
  const {togglePortal, openPortal, originRef, menuPortal, menuProps} = useMenu(
    MenuPosition.UPPER_RIGHT,
    {menuContentRef, id: 'topBarNotificationsMenu'}
  )
  const {location} = useRouter()
  useEffect(() => {
    const parsed = new URLSearchParams(location.search)
    if (parsed.get('openNotifs')) {
      // :HACK: Opening the portal immediately sometimes leads to rendering just off the left side
      // of the window, so delay a bit before opening. This might be benefial regardless, as it
      // catches the user's attention when it opens shortly after the rest of the page loads.
      setTimeout(openPortal, 500)
    }
  }, [])

  return (
    React.createElement(React.Fragment, null
      , React.createElement(TopBarIcon, {
        ref: originRef,
        onClick: togglePortal,
        onMouseEnter: NotificationDropdown.preload,
        icon: 'notifications',
        hasBadge: hasNotifications,
        ariaLabel: 'Notifications',}
      )
      , menuPortal(
        React.createElement(NotificationDropdown, { parentRef: menuContentRef, menuProps: menuProps, queryRef: data,} )
      )
    )
  )
}

export default TopBarNotifications
